import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStarUserPermission } from '@/utils/useStarUserPermission'

/** 体验用户，需展示解锁蒙层 */
export const TRIAL_STAR_LEVEL = -3

/** pending：权限确认中；locked：需解锁；unlocked：正常展示 */
export type TemplateLockState = 'pending' | 'locked' | 'unlocked'

export function useStarTemplateLock() {
  const route = useRoute()
  const { permission, isReady, loadPermission } = useStarUserPermission()

  const isTrialTemplateLocked = computed(() => {
    const p = permission.value
    if (!p) return false
    return p.starLevel === TRIAL_STAR_LEVEL
  })

  const templateLockState = computed<TemplateLockState>(() => {
    const token = route.query.token as string
    if (!token) return 'unlocked'
    if (!isReady.value) return 'pending'
    return isTrialTemplateLocked.value ? 'locked' : 'unlocked'
  })

  /** @deprecated 请优先使用 templateLockState */
  const effectiveTemplateLocked = computed(() => templateLockState.value === 'locked')

  return {
    isTrialTemplateLocked,
    isTemplateLockReady: isReady,
    templateLockState,
    effectiveTemplateLocked,
    loadStarTemplateLock: loadPermission,
  }
}
